import { Accordion, AccordionItem, Box, Text } from 'braid-design-system';

import { FILTER_COLLAPSED_SUMMARY_MAX_DISPLAY_COUNT } from '../constants';
import type { Suggestion } from '../types';

interface Props {
  id: string;
  expanded: boolean;
  label: string;
  children: React.ReactNode;
  selectedItems: Suggestion[];
  onToggle: (expanded: boolean) => void;
}

export const FilterAccordion = ({
  id,
  expanded,
  label,
  children,
  selectedItems,
  onToggle,
}: Props) => {
  const renderCollapsedSummary = () => {
    const remainingCount =
      selectedItems.length - FILTER_COLLAPSED_SUMMARY_MAX_DISPLAY_COUNT;

    const renderMaxSelectedItemsToString = (maxDisplayCount: number) =>
      selectedItems
        .slice(0, maxDisplayCount)
        .map((item) => item.name)
        .join(', ');

    return (
      <Box>
        <Text size="small" tone="secondary">
          {renderMaxSelectedItemsToString(
            FILTER_COLLAPSED_SUMMARY_MAX_DISPLAY_COUNT,
          )}
          {remainingCount > 0 && <> +{remainingCount}</>}
        </Text>
      </Box>
    );
  };

  return (
    <Accordion dividers={false} size="small">
      <AccordionItem
        id={id}
        label={label}
        expanded={expanded}
        onToggle={onToggle}
      >
        <Box marginTop="xsmall">{children}</Box>
      </AccordionItem>

      {!expanded && selectedItems.length > 0 && renderCollapsedSummary()}
    </Accordion>
  );
};
